import React, { useRef } from 'react';
import { Dropdown } from 'react-bootstrap';
import MoreVert from '@mui/icons-material/MoreVert';
import ListAlt from '@mui/icons-material/ListAlt';
import DeleteOutline from '@mui/icons-material/DeleteOutline';
import './FinancialActionsMenu.css';

let idCounter = 0;

export const ListRow = ({
  labelPrimary,
  labelSecondary,
  value,
  primaryText = false,
  firstActionLabel,
  onFirstAction,
  secondActionLabel,
  onSecondAction,
}) => {
  const toggleId = useRef(`list-row-actions-toggle-${idCounter++}`);

  return (
    <div
      className="d-flex justify-content-between align-items-center"
    >
      <span style={{ fontSize: 14 }}>
        {labelPrimary}
        {labelSecondary && (
          <>
            <span style={{ color: '#9ca3af' }}> | </span>
            <span style={{ color: '#9ca3af', textDecoration: 'underline' }}>
              {labelSecondary}
            </span>
          </>
        )}
      </span>
      <div className="d-flex align-items-center" style={{ gap: 12 }}>
        {value && (<span className={primaryText ? 'primary' : ''} style={{ fontSize: 14, fontWeight: 600 }}>{value}</span>)}
        <Dropdown alignRight>
          <Dropdown.Toggle
            bsPrefix="financial-actions-toggle"
            variant="link"
            className="btn btn-icon"
            style={{ borderColor: '#D1D3E0' }}
            id={toggleId.current}
          >
            <MoreVert style={{ color: 'black' }} />
          </Dropdown.Toggle>
          <Dropdown.Menu className="dropdown-menu">
            <Dropdown.Item
              className="d-flex align-items-center"
              style={{ borderBottom: '1px solid #EBEDF3' }}
              onClick={onFirstAction}
            >
              <ListAlt fontSize="small" className="mr-2" />
              {firstActionLabel}
            </Dropdown.Item>
            <Dropdown.Item
              className="d-flex align-items-center text-danger"
              onClick={onSecondAction}
            >
              <DeleteOutline fontSize="small" className="mr-2" />
              {secondActionLabel}
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </div>
  );
};
